<div class="d-flex flex-column flex-lg-row flex-wrap types-container">
    @for (inputType of inputTypes; track inputType; let last = $last) {
        <adapt-input-type [inputType]="inputType"
                          [canvas]="canvas"
                          [ngClass]="{ 'w-100': last, 'half-column': !last }"></adapt-input-type>
    }
</div>
